import { useMemo } from 'react';
import { ANIMATION_DURATION, SIDEBAR_DIMENSIONS } from './constants';

/**
 * Hook that returns memoized style objects for sidebar components.
 * Prevents unnecessary style object recreation on each render.
 */
export function useSidebarStyles(isCollapsed: boolean) {
  return useMemo(() => {
    const sidebarWidth = isCollapsed
      ? `${SIDEBAR_DIMENSIONS.MAIN_COLLAPSED_PX}px`
      : `${SIDEBAR_DIMENSIONS.MAIN_EXPANDED_PX}px`;

    const transition = `${ANIMATION_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1)`;

    return {
      sidebar: {
        width: sidebarWidth,
        transition: `width ${transition}`,
      },
      container: {
        width: sidebarWidth,
        transition: `width ${transition}`,
      },
      logoSection: {
        height: `${SIDEBAR_DIMENSIONS.LOGO_SECTION_HEIGHT_PX}px`,
        paddingLeft: isCollapsed ? '12px' : '16px',
        paddingRight: isCollapsed ? '12px' : '16px',
        transition: `padding-left ${transition}, padding-right ${transition}`,
      },
      nav: {
        paddingTop: isCollapsed ? '8px' : '16px',
        paddingBottom: isCollapsed ? '8px' : '16px',
        transition: `padding-top ${transition}, padding-bottom ${transition}`,
      },
      footer: {
        paddingTop: isCollapsed ? '8px' : '12px',
        paddingBottom: isCollapsed ? '8px' : '12px',
        transition: `padding-top ${transition}, padding-bottom ${transition}`,
      },
      sectionsContainer: {
        gap: isCollapsed ? '0' : '24px',
        flexGrow: 0,
        transition: `gap ${transition}`,
      },
    };
  }, [isCollapsed]);
}
